import { createRouter, createWebHistory } from 'vue-router'
import Players from '@/views/Players.vue'
import Devices from '@/views/Devices.vue'
import Files from '@/views/Files.vue'
import ScheduleEditor from '@/views/ScheduleEditor.vue'
import Player from '@/views/Player.vue'
import Headline from '@/views/Headline.vue'
import Login from '@/views/Login.vue'
import Schedule from '@/views/Schedule.vue'
import Playlists from "@/views/Playlists.vue";
import ScheduleAnalytics from '@/views/ScheduleAnalytics.vue';
import PageConstructor from '../views/PageConstructor.vue';
import FileAnalytics from '@/views/FileAnalytics.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/players',
    name: 'Players',
    component: Players
  },
  {
    path: '/device',
    name: 'Devices',
    component: Devices
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule
  },
  {
    path:'/playlists',
    name:'Playlists',
    component: Playlists
  },
  {
    path: '/files',
    name: 'Files',
    component: Files
  },
  {
    path: '/files/:id',
    name: 'Directory',
    component: Files
  },
  {
    path: '/headlines',
    name: 'Headline',
    component: Headline
  },
  {
    path: '/edit/:id',
    name: 'ScheduleEditor',
    component: ScheduleEditor
  },
  {
    path: '/players/:id',
    name: 'Player',
    component: Player
  },
  {
    path: '/analytics/:id',
    name: 'ScheduleAnalytics',
    component: ScheduleAnalytics,
    props: true
  },
  {
    path: '/pageconstructor',
    name: 'PageConstructor',
    component: PageConstructor
  },
  {
    path: '/file/:id',
    name: 'File',
    component: FileAnalytics,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
